import { CheckNullParams } from "../utils/CheckNullParams";
import axiosClient from "./axiosClient";

const ghtkApi = {
  getShipping: (params) => {
    const url = "/ghtk/getDeliveredAddress";
    const payload = CheckNullParams(params);
    return axiosClient.get(url, {
      params: payload,
    });
  },

  getFeeGhtk: (params) => {
    const url = "/ghtk/fee";
    const payload = CheckNullParams(params);
    return axiosClient.get(url, {
      params: payload,
    });
  },

  createOrder: (params) => {
    const url = "/ghtk/createOrder";
    const payload = CheckNullParams(params);
    return axiosClient.post(url, payload);
  },

  getStatusOrder: (label_id) => {
    const url = "/ghtk/getStatus/" + label_id;
    return axiosClient.get(url);
  },

  cancelOrderGhtk: (payload) => {
    const url = "/ghtk/cancelOrder";
    return axiosClient.post(url, payload);
  },

  getLabelOrder: (labelId) => {
    const url = "/ghtk/getLabel/" + labelId;
    return axiosClient.get(url, { responseType: "arraybuffer" });
  },
};

export default ghtkApi;
